module.exports = __webpack_public_path__ + "src/assets/img/TireVanguarder.40825495.svg";